var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex flex-col custom-background",attrs:{"id":"app"}},[_c('dark-nav'),_c('div',{staticClass:"flex-grow mobstyle px-4 sm:px-6 lg:px-12 xl:px-0",attrs:{"id":"main"}},[_c('flash-message'),_c('main',[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }